import { CloseOutlined } from "@ant-design/icons";
import { Button, Flex, Modal } from "antd";
import { useTranslation } from "react-i18next";

import ApiVersion from "@/modules/api-version";
import AppVersion from "@/modules/app-version";
import { AppCopyright } from "@/ui/app-copyright";
import { AppLogo } from "@/ui/app-logo";
import { AppSlogan } from "@/ui/app-slogan";

import { useAboutModal } from "./about-modal.hook";

import "./about-modal.style.less";

const AboutModal = () => {
  const { t } = useTranslation();
  const { isAboutOpen, closeAboutModal } = useAboutModal();

  return (
    <Modal
      open={isAboutOpen}
      onCancel={closeAboutModal}
      title={t("global:about.title")}
      className="about-modal"
      footer={
        <Button icon={<CloseOutlined />} onClick={closeAboutModal}>
          {t("global:about.closeButton")}
        </Button>
      }
    >
      <ApiVersion />
      <AppVersion />
      <AppLogo />
      <Flex vertical>
        <AppCopyright />
        <AppSlogan />
      </Flex>
    </Modal>
  );
};

export default AboutModal;
